import requests from "./httpServices";
import { setToken, getApiBaseUrl } from "./httpServices";
import { showErrorAlert } from "./AlertService";
import axios from "axios";

const ProfileServices = {
  getMyProfile: async () => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);

      const response = await requests.get("/profile/my");
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  updateMyProfile: async (profileData) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);

      const response = await requests.put("/profile/my", profileData);
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },

  uploadAvatar: async (file) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found");
      }

      const formData = new FormData();
      formData.append('avatar', file);

      // Use axios directly for FormData uploads
      const API_BASE_URL = getApiBaseUrl();
      const response = await axios.post(
        `${API_BASE_URL}profile/avatar`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
};

export default ProfileServices;

